import { launchHypervergeKYCWidget } from 'helpers/hyperverge';
import { addLogsToSentry } from 'helpers/sentry';
import { PossibleHypervergeKYCResultStatus } from 'types/hyperverge';
import DeltaButton, { DeltaButtonProps } from 'UIKit/DeltaButton';

import { WorkflowData } from './Disable2faFaceAuth.types';

const HypervergeFaceAuth = ({
  workflowData,
  onSdkResult,
  onSdkFail,
  text,
  className,
  loading,
  onClickTracking,
}: {
  workflowData: WorkflowData | null;
  text: string;
  onSdkResult: (result: PossibleHypervergeKYCResultStatus) => void;
  onSdkFail: () => void;
  className?: string;
  loading?: DeltaButtonProps<'button'>['loading'];
  // mostly used for tracking events
  onClickTracking?: () => void;
}) => {
  const onClick = async () => {
    if (!workflowData) {
      onSdkFail();
      return;
    }

    requestAnimationFrame(() => {
      onClickTracking?.();
    });

    try {
      const result = await launchHypervergeKYCWidget(
        {
          workflowId: workflowData.workflowId,
          accessToken: workflowData.authToken,
          transactionId: workflowData.transactionId,
        },
        { uid: workflowData.uid }
      );

      onSdkResult(result.finalStatus);
    } catch (error) {
      addLogsToSentry({}, error ?? 'Disable 2fa face auth failed');

      onSdkFail();
    }
  };

  return (
    <DeltaButton
      data-testid="hyperverge-face-auth"
      className={className}
      onClick={onClick}
      loading={loading}
    >
      {text}
    </DeltaButton>
  );
};
export { HypervergeFaceAuth };
